<template>
  <div
    :class="['resize-column', class_by_val + '-resize' , { 'active': hover || pageX }]"
    @click.stop
    @mousedown="mousedown"
    @mouseout="mouseout"
    @mouseover="mouseover"/>
</template>

<script>
export default {
  name: 'resizeColumnDiv',
  data() {
    return {
      pageX: null,
      hover: false,
      width: null
    }
  },
  props: {
    value: String,
    resize_all_tables: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    class_by_val() {
      return this.value.replaceAll('.', '_')
    }
  },
  methods: {
    mousedown(ev) {
      this.pageX = ev.pageX
      document.addEventListener('mousemove', this.mousemove)
      document.addEventListener('mouseup', this.mouseup)
    },

    mousemove(ev) {
      if ( this.pageX ) {
        let diffX = ev.pageX - this.pageX
        if ( this.resize_all_tables ) {
          let cells = []
          let divs = document.querySelectorAll(`.resize-column.${this.class_by_val}-resize`)
          divs.forEach(div => {
            cells.push(div.parentNode)
          })
          this.width = Math.max(...cells.map(it => it.offsetWidth )) + diffX + 'px'

          divs.forEach(div => {
            div.parentNode.style.width = this.width
            div.parentNode.style.minWidth = this.width
          })
        } else {
          this.width = this.$el.parentNode.offsetWidth + diffX + 'px'
          this.$el.parentNode.style.width = this.width
          this.$el.parentNode.style.minWidth = this.width
        }
        this.pageX = ev.pageX
      }
    },
    mouseup() {
      this.pageX = null
      this.$emit('mouseup', this.value, this.width )
      document.removeEventListener('mousemove', this.mousemove)
      document.removeEventListener('mouseup', this.mouseup)
      //this.$el.style.height = this.$el.closest('table').offsetHeight + 'px'
    },
    mouseout() {
      this.hover = false
    },
    mouseover() {
      this.hover = true
    },
  }
}
</script>
<style lang="scss" scoped>
.resize-column {
  position: absolute;
  background-color: transparent !important;
  width: 6px;
  top: 0;
  right: -3px;
  cursor: col-resize;
  &.active {
    &::before {
      content: '';
      background-color: var(--v-main__green-base) !important;
      height: 100%;
      width: 2px;

      position: absolute;
      right: 1px;
      z-index: 1;
    }
  }
}
</style>
<style lang="scss">
th:last-child .resize-column {
  width: 3px;
  right: 0px;
  &.active {
    &::before {
      right: 0px;
    }
  }
}
</style>
